import React from 'react';

import {Bullet} from 'commons/models';

export const data: Array<Bullet> = [
    {
        desc: '',
        secondaryLink: true,
        items: [
            {
                item: 0,
                sections: [
                    {
                        value: 'Requisitos de contrase\u00F1a',
                        title: 'Requisitos',
                        style: 'modal',
                        order: 0,
                        variant: 'link',
                        text: 'Debe contener las siguientes caracter\u00EDsticas:  | | A) Debe estar compuesta por al menos 8 caracteres. | | B) Debe contener al menos un car\u00E1cter en min\u00FAscula (a-z). | | C) Debe contener al menos un car\u00E1cter en may\u00FAscula (A-Z). | | D) Debe contener al menos un car\u00E1cter num\u00E9rico (0-9). | | E) Debe contener al menos un car\u00E1cter especial (@,#,$,%,&,*,+,-,<,>).',
                    },
                ],
            },
        ],
    },
];
